import React from 'react'
import moment from 'moment'
import cs from 'classnames'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import {dateFormatter} from 'lib/helpers'
import {eq} from 'lodash/lang'
import styles from './clientFinances.scss'
import NoResults from '../noResults'

import i18n from 'lib/i18n'
const _ = i18n('clientFinances')

const ClientTransactionsDom = ({items}) => (
	<div className="transContainer">
		<Table
			itemsPerPage={30}
			filterable={[
				'paymentReference',
				'invoiceNumber',
				'transactionDate',
				'transactionType',
				'returnReason',
				'collectType',
				'companyNumber',
				'productionNumber',
				'transactionContract',
				'transactionRisk',
				'transactionDateFrom',
				'transactionDateUntil',
				'amount',
				'reminder',
			]}
		>
			<Thead>
				<Th column="paymentReference"><span>{_('paymentReference')}</span></Th>
				<Th column="invoiceNumber"><span>{_('invoiceNumber')}</span></Th>
				<Th column="transactionDate"><span>{_('transactionDate')}</span></Th>
				<Th column="transactionType"><span>{_('transactionType')}</span></Th>
				<Th column="returnReason"><span>{_('returnReason')}</span></Th>
				<Th column="collectType"><span>{_('collectType')}</span></Th>
				<Th column="companyNumber"><span>{_('companyNumber')}</span></Th>
				<Th column="productionNumber"><span>{_('productionNumber')}</span></Th>
				<Th column="transactionContract"><span>{_('transactionContract')}</span></Th>
				<Th column="transactionRisk"><span>{_('transactionRisk')}</span></Th>
				<Th column="transactionDateFrom"><span>{_('transactionDateFrom')}</span></Th>
				<Th column="transactionDateUntil"><span>{_('transactionDateUntil')}</span></Th>
				<Th column="amount"><span>{_('amount')}</span></Th>
				<Th column="reminder"><span>{_('reminder')}</span></Th>
			</Thead>
			{items && items.map((r, key) =>
				<Tr key={key} className={cs(r.lineType === 'T' && styles.tType, 'centered')}>
					<Td column="paymentReference">{r.paymentReference}</Td>
					<Td column="invoiceNumber">{r.invoiceNumber}</Td>
					<Td column="transactionDate" data={dateFormatter(r.transactionDate)}/>
					<Td column="transactionType">{r.transactionType}</Td>
					<Td column="returnReason">{r.returnReason}</Td>
					<Td column="collectType">{r.collectType}</Td>
					<Td column="companyNumber">{r.companyNumber}</Td>
					<Td column="productionNumber">{r.productionNumber}</Td>
					<Td column="transactionContract">{r.transactionContract}</Td>
					<Td column="transactionRisk">{r.transactionRisk}</Td>
					<Td column="transactionDateFrom" data={dateFormatter(r.transactionDateFrom)}/>
					<Td column="transactionDateUntil" data={dateFormatter(r.transactionDateUntil)}/>
					<Td column="amount">{r.amount}</Td>
					<Td column="reminder">{r.reminder && _(r.reminder)}</Td>
				</Tr>
			)}
		</Table>
		{items && items.length === 0 &&
			<NoResults type="transactions"/>
		}
	</div>
)
ClientTransactionsDom.propTypes = {
	items: React.PropTypes.array,
}

export default ClientTransactionsDom



// WEBPACK FOOTER //
// ./components/clients/clientTransactions.jsx